import React from 'react'
import { Radar } from '@nivo/radar'
import compact from 'lodash/compact'

import { COLORS_OPACITY_08, DIRECT, PEERS, SELF, SUPERVISORS } from '../Reports'
import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'

const theme = {
  axis: {
    ticks: {
      text: {
        fontSize: 12,
      },
    },
  },
  dots: {
    text: {
      fontSize: 14,
    },
  },
}

const LabelComponent = ({ id, anchor }) => {
  const offsetX = id.length
  return (
    <g transform={`translate(${anchor === 'end' ? -offsetX * 8 : anchor === 'middle' ? -offsetX * 4 : 0}, 0)`}>
      <text
        style={{
          fontSize: '13px',
          fontFamily: 'Avenir, sans-serif',
          fontWeight: 500,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.54,
          letterSpacing: 'normal',
          fill: '#626262',
        }}
      >
        {id.toUpperCase()}
      </text>
    </g>
  )
}

const RadarChart = ({ data, reviewers }) => {
  // this need for removing empty reviewersTypes
  const updatedData = data.map(competency => {
    if (!reviewers[TYPE_OF_REVIEWERS.SUPERIOR]) {
      delete competency.Supervisors
    }
    if (!reviewers[TYPE_OF_REVIEWERS.PEER]) {
      delete competency.Peers
    }
    if (!reviewers[TYPE_OF_REVIEWERS.EMPLOYEE]) {
      delete competency.Direct
    }
    return competency
  })
  // this need for removing empty reviewersTypes
  const keys = []
  keys[0] = SELF
  if (reviewers[TYPE_OF_REVIEWERS.PEER]) {
    keys[1] = PEERS
  }
  if (reviewers[TYPE_OF_REVIEWERS.SUPERIOR]) {
    keys[2] = SUPERVISORS
  }
  if (reviewers[TYPE_OF_REVIEWERS.EMPLOYEE]) {
    keys[3] = DIRECT
  }
  const compactedKeys = compact(keys)
  return (
    <Radar
      data={updatedData}
      keys={compactedKeys}
      indexBy="competency"
      width={784}
      height={512}
      colors={(node: any) => {
        return COLORS_OPACITY_08[node.key]
      }}
      maxValue="auto"
      fillOpacity={0}
      margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
      blendMode="normal"
      gridLevels={4}
      gridShape="circular"
      curve="linearClosed"
      borderWidth={2}
      borderColor={{ from: 'color' }}
      gridLabelOffset={36}
      animate
      motionStiffness={90}
      motionDamping={15}
      isInteractive
      theme={theme}
      gridLabel={LabelComponent}
      legends={[
        {
          itemOpacity: 0,
          anchor: 'top-left',
          direction: 'column',
          translateX: -50,
          translateY: -40,
          itemWidth: 80,
          itemHeight: 20,
          itemTextColor: '#999',
          symbolSize: 12,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000',
              },
            },
          ],
        },
      ]}
    />
  )
}

export default RadarChart
